import { createFileRoute } from '@tanstack/react-router';
import type { Partner } from '@doorly/shared';
import { PartnerForm } from '../features/partners/PartnerForm';
import { RequireRole } from '../components/RequireRole';
import { useApiQuery } from '../lib/api';

function EditPartner() {
  const { partnerId } = Route.useParams();
  const q = useApiQuery<Partner>(['partner', partnerId], `/partners/${partnerId}`);
  if (q.isLoading) return <p className="text-ink-mute text-body">Chargement…</p>;
  if (q.error) {
    return (
      <pre className="rounded-lg bg-red-50 border border-red-200 text-red-700 p-3 text-meta">
        {q.error instanceof Error ? q.error.message : String(q.error)}
      </pre>
    );
  }
  if (!q.data) return null;
  return <PartnerForm partner={q.data} />;
}

export const Route = createFileRoute('/partners/$partnerId')({
  component: () => (
    <RequireRole allow={['admin']}>
      <EditPartner />
    </RequireRole>
  ),
});
